// extracted by mini-css-extract-plugin
export default {"tableValue":"response-user-name_tableValue__2nh9T"};